import React from 'react'
import PropTypes from 'prop-types'
import PromotionItem from './PromotionItem'
import { ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const PromotionListItem = (props) => {
  return (
    <li
      className={`promotion-item ${props.textAlignmentClass} ${props.itemInRowClass} ${props.item.url ? 'link' : ''} ${ACCESSIBILITY_CLASSES.main}` }
      tabIndex={TAB_INDEXES.PromotionItem}
      role="button"
    >
      <PromotionItem {...props} />
    </li>
  )
}

PromotionListItem.propTypes = {
  item: PropTypes.object.isRequired,
  itemInRowClass: PropTypes.string.isRequired,
  textAlignmentClass: PropTypes.string
}

export default PromotionListItem
